import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import { ThemeProvider } from "./lib/theme";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";

import SiteLayout from "./layout/SiteLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Consultations from "./pages/Consultations";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import LegalPage from "./pages/LegalPage";
import Payment from "./pages/Payment";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminBlog from "./admin/AdminBlog";
import AdminCourses from "./admin/AdminCourses";
import AdminTestimonials from "./admin/AdminTestimonials";
import AdminConsultations from "./admin/AdminConsultations";
import AdminEnquiries from "./admin/AdminEnquiries";
import AdminPayments from "./admin/AdminPayments";
import AdminReviews from "./admin/AdminReviews";
import AdminShareTools from "./admin/AdminShareTools";
import AdminAstrologyTools from "./admin/AdminAstrologyTools";
import Feedback, { FeedbackThankYou } from "./pages/Feedback";
import KundaliGenerator from "./pages/KundaliGenerator";
import JanamNakshatra from "./pages/JanamNakshatra";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/consultations" element={<Consultations />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:id" element={<CourseDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<LegalPage kind="privacy" />} />
              <Route path="/terms" element={<LegalPage kind="terms" />} />
              <Route path="/refund-policy" element={<LegalPage kind="refund" />} />
              <Route path="/disclaimer" element={<LegalPage kind="disclaimer" />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/feedback/thank-you" element={<FeedbackThankYou />} />
              <Route path="/kundali-generator" element={<KundaliGenerator />} />
              <Route path="/janam-nakshatra" element={<JanamNakshatra />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="courses" element={<AdminCourses />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="share-tools" element={<AdminShareTools />} />
              <Route path="astrology-tools" element={<AdminAstrologyTools />} />
              <Route path="consultations" element={<AdminConsultations />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="payments" element={<AdminPayments />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
